import { QuizLiveInfo } from '../types/quiz';

/**
 * Shared status predicates over `QuizLiveInfo.status`, so "running" and
 * "ended" have exactly one definition across the quiz list, the card, and
 * the polling-interval logic — they used to only live inside
 * `LiveQuizCard`'s state machine, which meant anything else touching a live
 * quiz's status risked drifting from it.
 */

export function isLiveQuizRunning(live: QuizLiveInfo): boolean {
  return live.status === 'question' || live.status === 'reveal' || live.status === 'scoreboard';
}

export function isLiveQuizEnded(live: QuizLiveInfo): boolean {
  return live.status === 'finished' || live.status === 'abandoned';
}

/** Neither running nor ended: before the lobby, or waiting in it. */
export function isLiveQuizPreStart(live: QuizLiveInfo): boolean {
  return !isLiveQuizRunning(live) && !isLiveQuizEnded(live);
}
